import React from 'react';
import PropTypes from 'prop-types';
import { Carousel } from '@bingads-webui-react/primitive-unthemed';
import { MultiLineEllipsisText } from '@bingads-webui-react/multiline-ellipsis';
import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';
import { ImageExperienceImage, constants as C } from '@bingads-webui-campaign-react/image-experience-model';

export class MultiImagePreview extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.multiLineTextRefs = [
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
    ];

    this.state = {
      index: 0,
      direction: null,
    };
  }

  componentDidUpdate() {
    this.multiLineTextRefs.forEach((ref) => {
      if (ref.current) {
        ref.current.processText();
      }
    });
  }

  handleSelect = (selectedIndex, e) => {
    this.setState({
      index: selectedIndex,
      direction: e.direction,
    });
  }

  render() {
    const imageContainerClassName = 'image-container';
    const { index, direction } = this.state;

    return (
      <div className="image-combo-contanier">
        <div className={imageContainerClassName}>
          {
            this.props.isInsideImages &&
            <div>
              <CroppedImageView
                resizeImageHeight={this.props.imagePreviewHeight}
                src={this.props.images[0].Src}
                originalWidth={this.props.images[0].Width}
                originalHeight={this.props.images[0].Height}
                SourceX={this.props.images[0].CropSettings.SourceX}
                SourceY={this.props.images[0].CropSettings.SourceY}
                SourceWidth={this.props.images[0].CropSettings.SourceWidth}
                SourceHeight={this.props.images[0].CropSettings.SourceHeight}
                aspectRatio={C.aspectRatios[this.props.images[0].Type].aspectRatio}
              />
              <div className="text-container">
                <MultiLineEllipsisText
                  ref={this.multiLineTextRefs[0]}
                  className="extension-headline"
                  text={this.props.previewTexts.extensionHeadline}
                />
              </div>
            </div>
          }
          {
            !this.props.isInsideImages &&
            <div>
              <Carousel
                activeIndex={index}
                direction={direction}
                onSelect={this.handleSelect}
                controls={false}
                wrap={false}
              >
                {
                  this.props.images.map(imageObj => (
                    <Carousel.Item key={imageObj.idString}>
                      <span className="ad-logo">
                        <p>
                          {this.props.i18n.getString('Entity_Ads')}
                        </p>
                      </span>
                      <CroppedImageView
                        resizeImageHeight={this.props.imagePreviewHeight}
                        src={imageObj.Src}
                        originalWidth={imageObj.Width}
                        originalHeight={imageObj.Height}
                        SourceX={imageObj.CropSettings.SourceX}
                        SourceY={imageObj.CropSettings.SourceY}
                        SourceWidth={imageObj.CropSettings.SourceWidth}
                        SourceHeight={imageObj.CropSettings.SourceHeight}
                        aspectRatio={C.aspectRatios[imageObj.Type].aspectRatio}
                      />
                    </Carousel.Item>
                  ))
                }
              </Carousel>
              <div className="text-container">
                <MultiLineEllipsisText
                  ref={this.multiLineTextRefs[0]}
                  className="long-headline"
                  text={this.props.previewTexts.longHeadline}
                />
                <MultiLineEllipsisText
                  ref={this.multiLineTextRefs[1]}
                  className="final-url"
                  text={this.props.previewTexts.url}
                />
                <MultiLineEllipsisText
                  ref={this.multiLineTextRefs[2]}
                  className="description"
                  text={this.props.previewTexts.description}
                />
              </div>
            </div>
          }
        </div>

      </div>
    );
  }
}

MultiImagePreview.propTypes = {
  images: PropTypes.arrayOf(PropTypes.instanceOf(ImageExperienceImage)).isRequired,
  previewTexts: PropTypes.shape({
    longHeadline: PropTypes.string,
    extensionHeadline: PropTypes.string,
    description: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
  imagePreviewHeight: PropTypes.number,
  isInsideImages: PropTypes.bool,
};

MultiImagePreview.defaultProps = {
  imagePreviewHeight: null,
  isInsideImages: false,
};
